const PROBATION_PLAN = 'probation_plan';


export default {
  PROBATION_PLAN,
};
